import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, DropdownButton, Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Api from '../../services/ApiService';
import MaterialSearch from '../MaterialSearch';
import { updateUserData } from '../../actions/AppActions';
import Form from '../form/Form';

class PrintLogToolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      count: 0,
      loading: false,
      page: 1,
      searchQuery: '',
    };

    this.limit = 1000;
    this.from = 0;
    this.form = {
      startDate: '',
      endDate: '',
    };

    this.layout = [
      {
        name: 'startDate',
        col: 3,
        label: 'Start Date',
        type: 'date',
      },
      {
        name: 'endDate',
        col: 3,
        label: 'End Date',
        type: 'date',
      },
      {
        // TODO change to a better multi-select component
        name: 'overallStatus',
        label: 'Status',
        data: [],
        control: 'Tags',
        col: 6,
        validation: {
          type: 'static',
          suggestions: [
            { value: 'done', name: 'Done' },
            { value: 'active', name: 'Active' },
            { value: 'failed', name: 'Failed' },
            { value: 'dead', name: 'Dead' },
          ],
        },
      },
    ];

    this.handleSearch = this.handleSearch.bind(this);
    this.getData = this.getData.bind(this);
    this.toggleGraph = this.toggleGraph.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
    this.debouncedGetData = _.debounce(this.getData, 500);
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.sortModel !== prevProps.sortModel) {
      this.getData();
    }
  }

  getData() {
    const { sortModel } = this.props;

    this.setState({ loading: true });

    return Api.get('print/jobs', {
      params: {
        q: this.state.searchQuery,
        from: this.from,
        limit: this.limit,
        agSort: sortModel ? btoa(JSON.stringify(sortModel)) : '',
        agFilter: this.filter ? btoa(JSON.stringify(this.filter)) : '',
        params: this.form,
      },
    }).then(({ data }) => {
      if (!data.docs || !data.docs.length) {
        this.setState({ count: 0, loading: false });
        this.props.handleSearch([]);
      } else {
        this.setState({ count: data.docs.length, loading: false });
        this.props.handleSearch(data.docs);
      }
    });
  }

  toggleGraph() {
    this.props.updateUserData('print.showGraph', !this.props.showGraph);
  }

  handleSearch(event) {
    this.setState({ searchQuery: event.target.value }, this.debouncedGetData);
  }

  handlePageChange(page) {
    this.setState({ page });
    this.from = (page - 1) * this.limit;
    this.getData();
  }

  handleFormChange({ form }) {
    _.each(form, (value, key) => {
      this.form[key] = value.data;
    });
    this.getData();
  }

  renderActionButton() {
    if (this.props.user.username !== 'dsisupport') {
      return (
        <DropdownButton
          variant="primary"
          title="Actions"
          alignRight
          id="printLog-dropdown"
          className="d-inline-block ml-1"
        >
          <Dropdown.Item onClick={this.toggleGraph}>Toggle Graph</Dropdown.Item>
        </DropdownButton>
      );
    }

    return (
      <DropdownButton
        variant="primary"
        title="Actions"
        alignRight
        id="printLog-dropdown"
        className="d-inline-block ml-1"
      >
        <Dropdown.Item onClick={this.props.handleRetryJobs}>Retry Failed Jobs</Dropdown.Item>
        <Dropdown.Item onClick={this.props.handleResubmitJobs}>Resubmit Jobs</Dropdown.Item>
        <Dropdown.Item onClick={this.props.handleCancelJobs}>Cancel Jobs</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={this.toggleGraph}>Toggle Graph</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item onClick={this.props.handleReindexSearch}>Reindex Search</Dropdown.Item>
      </DropdownButton>
    );
  }

  renderPagination() {
    const { page, count } = this.state;
    return (
      <>
        <Button
          disabled={page <= 1}
          onClick={() => this.handlePageChange(page - 1)}
          variant="secondary"
          className="d-inline-block ml-1"
        >
          Prev
        </Button>
        <Button
          disabled={count < this.limit}
          onClick={() => this.handlePageChange(page + 1)}
          variant="secondary"
          className="d-inline-block ml-1"
        >
          Next
        </Button>
      </>
    );
  }

  render() {
    const { loading, count, searchQuery } = this.state;

    return (
      <div id="list-toolbar-wrapper">
        <div id="list-toolbar">
          <div style={{ float: 'right', marginLeft: '5px' }}>
            {this.renderActionButton()}
            {this.renderPagination()}
          </div>
          <MaterialSearch
            onChange={this.handleSearch}
            loading={loading}
            results={count}
            maxResults={this.limit}
            value={searchQuery}
          />
          <div className="clearfix" />
          <Form layout={this.layout} hideSubmit hideCancel onChange={this.handleFormChange} />
        </div>
      </div>
    );
  }
}

PrintLogToolbar.propTypes = {
  handleSearch: PropTypes.func,
  handleCancelJobs: PropTypes.func,
  handleResubmitJobs: PropTypes.func,
  handleRetryJobs: PropTypes.func,
  handleReindexSearch: PropTypes.func,

  showGraph: PropTypes.bool,
  sortModel: PropTypes.array,
  updateUserData: PropTypes.func,
  user: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    user: state.app.user,
    showGraph: _.get(state.app.userData, 'print.showGraph', true),
    sortModel: state.print.sortModel,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ updateUserData }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PrintLogToolbar);
